var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBumpersDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 950,
    height: 640,
    viewBox: "0 0 950 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.5C14 14.6716 14.6716 14 15.5 14H73.8642C74.2706 14 74.6595 14.1649 74.9421 14.4569L87.0389 26.9569C87.96 27.9087 87.2855 29.5 85.961 29.5H31C30.1716 29.5 29.5 30.1716 29.5 31V125.961C29.5 127.286 27.9087 127.96 26.9569 127.039L14.4569 114.942C14.1649 114.66 14 114.271 14 113.864V15.5Z",
    fill: "#BCD167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 623.5C14 624.329 14.6716 625 15.5 625H73.8642C74.2706 625 74.6595 624.836 74.9421 624.544L87.0389 612.044C87.96 611.092 87.2855 609.5 85.961 609.5H31.1368C30.3088 609.5 29.6374 608.83 29.6368 608.002L29.5054 449.525C29.5041 447.933 27.3496 447.44 26.6554 448.873L14.15 474.69C14.0513 474.894 14 475.118 14 475.344V623.5Z",
    fill: "#BCD167"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M935 16C935 15.1716 934.328 14.5 933.5 14.5H875.121C874.723 14.5 874.342 14.658 874.061 14.9393L862.061 26.9393C861.116 27.8843 861.785 29.5 863.121 29.5H918C918.828 29.5 919.5 30.1716 919.5 31V126.043C919.5 127.355 921.066 128.035 922.025 127.138L934.525 115.445C934.828 115.161 935 114.764 935 114.349V16Z",
    fill: "#BCD167"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M935 623.5C935 624.328 934.328 625 933.5 625H875.136C874.729 625 874.34 624.835 874.058 624.543L861.961 612.043C861.04 611.091 861.714 609.5 863.039 609.5H917.862C918.69 609.5 919.362 608.828 919.362 608V533.148L919.492 456.895C919.494 455.416 921.409 454.833 922.236 456.059L934.744 474.62C934.911 474.868 935 475.16 935 475.458V623.5Z",
    fill: "#BCD167"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBumpersDesktop);
export default __webpack_public_path__ + "static/media/bumpers_desktop.0d8452dee53aff2e4d16ce3b5710239a.svg";
export { ForwardRef as ReactComponent };